import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const AddSquare = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M23 4H9C6.237 4 4 6.237 4 9V23C4 25.762 6.237 28 9 28H23C25.762 28 28 25.762 28 23V9C28 6.237 25.762 4 23 4ZM26 23C26 24.65 24.65 26 23 26H9C7.35 26 6 24.65 6 23V9C6 7.35 7.35 6 9 6H23C24.65 6 26 7.35 26 9V23Z" />
		<path d="M21 15H17V11C17 10.45 16.55 10 16 10C15.45 10 15 10.45 15 11V15H11C10.45 15 10 15.45 10 16C10 16.55 10.45 17 11 17H15V21C15 21.55 15.45 22 16 22C16.55 22 17 21.55 17 21V17H21C21.55 17 22 16.55 22 16C22 15.45 21.55 15 21 15Z" />
	</svg>
);

export default AddSquare;
